import React, { useEffect } from 'react'; // Remove useEffect import
import useStrategyMonthYearSelector from '../../hooks/useStrategyMonthYearSelector';
import { getTranslatedMonth } from '../../helpers/localization';
import useLocalization from '../../hooks/useLocalization';

const MonthYearPicker = ({
  className = '',
  years = [],
  incompleteYears,
  month,
  year,
  onMonthChange,
  onYearChange,
  monthLabel,
  yearLabel,
  disabled,
  required
}) => {
  const { translate } = useLocalization();

  const {
    selectedMonth,
    selectedYear,
    onMonthChange: onMonthChangeInternal,
    onYearChange: onYearChangeInternal,
    monthOptions,
    yearOptions
  } = useStrategyMonthYearSelector({
    incompleteYearsOfStrategy: incompleteYears,
    strategyYears: years,
    initialYear: year,
    initialMonth: month
  });

  const handleMonthChange = value => {
    let numberValue = Number(value);
    let parsedValue = isNaN(numberValue) ? value : numberValue;
    onMonthChangeInternal(parsedValue);
    onMonthChange(parsedValue);
  };

  const handleYearChange = value => {
    let numberValue = Number(value);
    let parsedValue = isNaN(numberValue) ? value : numberValue;
    onYearChangeInternal(parsedValue);
    onYearChange(parsedValue);
  };

  useEffect(() => {
    onYearChange(selectedYear);
  }, [selectedYear]);

  useEffect(() => {
    onMonthChange(selectedMonth);
  }, [selectedMonth]);

  return (
    <div className={`d-flex justify-content-between gap-3 ${className}`}>
      <div className="flex-fill">
        <label className="mid" htmlFor="year">
          {yearLabel || translate('year')}
        </label>
        <select
          id="year"
          disabled={disabled}
          onChange={e => handleYearChange(e.target.value)}
          name="year"
          className="form-select form-select-sm mb-3"
          value={selectedYear || ''}
        >
          {!required && <option value=""></option>}
          {yearOptions.map(year => (
            <option value={year} key={year}>
              {year}
            </option>
          ))}
        </select>
      </div>
      <div className="flex-fill">
        <label className="mid" htmlFor="month">
          {monthLabel || translate('month')}
        </label>
        <select
          id="month"
          onChange={e => handleMonthChange(e.target.value)}
          name="month"
          disabled={disabled}
          className="form-select form-select-sm mb-3"
          value={selectedMonth || ''}
        >
          {monthOptions.map(month => (
            <option value={month} key={month}>
              {getTranslatedMonth(translate, month)}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default MonthYearPicker;
